import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, BlockDeleteRequest, BlockGetListRequest, BlockGetListResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class BlockService {

  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllBlocks(body: BlockGetListRequest) {
    const link = this.apiUrl + ApiUrls.getAllBlocks;
    return this.http.post<BlockGetListResponse>(link, body);
  }

  getBlockDetails(body: number) {
    const link = this.apiUrl + ApiUrls.getBlockDetails;
    return this.http.get<any>(link+ '/'+body);
  }

  deleteBlock(body: BlockDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteBlock;
    return this.http.post<BaseResponse>(link, body);
  }

  insertBlock(body: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.insertBlock;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }

  updateBlock(body: any) {
    const link = this.apiUrl + ApiUrls.updateBlock;
    return this.http.post<BaseResponse>(link, body);
  }

  getSeatMapping(body:any){
    const link = this.apiUrl + ApiUrls.getSeatMapping;
    return this.http.post<any>(link, body);
  }

  insertBlockSeatMapper(body: any) {
    const link = this.apiUrl + ApiUrls.insertBlockSeatMapper;
    return this.http.post<BaseResponse>(link, body);
  }

  updateBlockSeatMapper(body: any) {
    const link = this.apiUrl + ApiUrls.updateBlockSeatMapper;
    return this.http.post<BaseResponse>(link, body);
  }

}
